import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '../router';
// import VuexPersistence from 'vuex-persist'

/*const vuexLocal = new VuexPersistence({
    key:"animhead",
    storage: window.localStorage
})*/

Vue.use(Vuex);
const url = "https://dev.amdeveloper.fr/api";

export const store = new Vuex.Store({
    state: {
        medias: null,
        user: null,
        successBase: null,
        success: null,
        masks: [],
        logged: false,
        showFilters: true,
        showPicture: false,
        currentMedia: '',
        trophies: null,
        currentMask: null
    },
    mutations: {

        setMedias(state, medias) {
            state.medias = medias;
            localStorage.setItem('medias', JSON.stringify(state.medias));

        },
        setUser(state, user) {
            state.user = user;
            localStorage.setItem('user', JSON.stringify(state.user));

        },
        setMasks(state, masks) {
            state.masks = masks;
            localStorage.setItem('masks', JSON.stringify(state.masks));
        },
        setTrophies(state, trophies) {
            state.trophies = trophies;
            localStorage.setItem('trophies', JSON.stringify(state.trophies));
        },
        setProducts(state, products) {
            // state.products = products
            // localStorage.setItem('products',JSON.stringify(state.products))
        },
        setLog(state, log) {
            state.logged = log;
            localStorage.setItem('log', state.logged);

        },
        deleteLastMedia(state) {
            state.medias.splice(-1, 1);
            localStorage.setItem('medias', JSON.stringify(state.medias));
        },
        deleteMedia(state, media) {
            let index = state.media.indexOf(media);
            if (index > -1) {
                state.medias.splice(index, 1);
            }
            localStorage.setItem('mediasPicture', JSON.stringify(state.medias));
        },
        setSuccess(state, data) {
            state.success = data;
        },
        setSuccessBase(state, data) {
            state.successBase = data;
        },
        setCurrentMask(state, data) {
            state.currentMask = data;
        }
    },
    getters: {
        getMedias: state => state.medias,
        getUser: state => state.user ? state.user : JSON.parse(localStorage.getItem('user')),
        getShowFilters: state => state.showFilters,
        getShowPicture: state => state.showPicture,
        getCurrentMedia: state => state.currentMedia,
    },
    actions: {
        changeCurrentMask(context, currentmask) {
            context.commit('setCurrentMask', currentmask);
        },
        login(context, data) {
            let dataArray = {
                name: data.pseudo,
                password_crypt: data.password
            }
            return axios
                .post(url + '/login', {data: btoa(JSON.stringify(dataArray))})
                .then(res => {
                    if (res.data.status_code === 200) {
                        this.dispatch('getUser', res.data.value).then(() => router.push({name: "camera"}));
                    } else {
                        toggleLoader()
                    }

                    return [{msg: res.data.message, type: 'error'}]

                })
                .catch(error => console.log(error))
        },
        register(context, data) {
            let dataArray = {
                name: data.pseudo,
                email: data.email,
                code: data.code,
                checkregister: data.checkregister
            }
            return axios
                .post(url + '/register', {data: btoa(JSON.stringify(dataArray))}
                )
                .then(res => {
                    if (res.data.status_code === 200) {
                        return [{msg: res.data.msg, type: 'succeed'}];
                    } else {
                        return res.data.map(el => {
                            return {msg: el, type: 'error'}
                        });

                    }
                })
                .catch(error => console.log(error))
        },
        getUser(context, id) {
            return axios
                .get(url + '/user/' + id)
                .then(res => {
                    toggleLoader()
                    context.commit('setUser', res.data.user)
                    context.commit('setMasks', res.data.product_list)

                })
                .catch(error => console.log(error))

        },
        getGames(context, id) {
            return axios
                .get(url + '/user/' + id)
                .then(res => {
                    toggleLoader()
                    context.commit('setUser', res.data.user)
                    context.commit('setMasks', res.data.product_list)
                })
                .catch(error => console.log(error))
        },
        getMask(context, qrcode_uid) {
            return axios
                .get(url + '/getmask/' + qrcode_uid)
                .then(res => {
                    let dataresult = res.data
                    if (res.data.status_code === 200) {
                        let data = [
                            {
                                tag: 'scan',
                                qrcode_uid: qrcode_uid,

                            }
                        ]
                        this.dispatch('getUser', store.state.user.id)

                        return this.dispatch('checkSuccess', data).then(res => {
                            toggleLoader()
                            res.value = dataresult.value
                            return res
                        })
                    }

                    return res.data
                })
                .catch(err => console.log(err))
        },
        getMasks() {
            return axios
                .get(url + '/allmask')
                .then(res => {
                    return res.data
                    //RETURN object Product with mask and texture path
                })
                .catch(err => console.log(err))
        },
        addMask(context, qrcode_uid) {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .post(url + '/user/' + userId + '/addmask', {product_id: qrcode_uid})
                .then(res => {

                    if (res.data.status_code === 200) {
                        let data = [
                            {
                                tag: 'addmask',
                                qrcode_uid: qrcode_uid,

                            }
                        ]
                        this.dispatch('getUser', store.state.user.id)

                        return this.dispatch('checkSuccess', data).then(res => {
                            toggleLoader()
                            return res
                        })
                    }
                    this.dispatch('getUser', store.state.user.id)

                    return res

                })
                .catch(err => console.log(err))
        },
        addPicture(context, picture) {
            toggleLoader()
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .post(url + '/user/' + userId + '/addpicture', {media: picture})
                .then(res => {

                    //this.dispatch('getUser',store.state.user.id)
                    if (res.data.status_code === 200) {
                        let data = [
                            {
                                tag: 'duplicate',
                                duplicate: picture.duplicate,
                                qrcode_uid: picture.qrcode_uid,

                            }
                        ]

                        return this.dispatch('checkSuccess', data).then(res => {
                            toggleLoader()
                            return res
                        })
                    }
                    // toggleLoader()

                    return res

                })
                .catch(err => console.log(err))

        },
        sharedPicture(context, picture) {
            toggleLoader()
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .post(url + '/user/' + userId + '/sharepicture/' + picture)
                .then(res => {

                    //this.dispatch('getUser',store.state.user.id)
                    if (res.data.status_code === 200) {
                        let data = [
                            {
                                tag: 'share',

                            }
                        ]

                        return this.dispatch('checkSuccess', data).then(res => {
                            toggleLoader()
                            return res
                        })
                    }
                    // toggleLoader()

                    return res

                })
                .catch(err => console.log(err))

        },
        deletePicture(context, picture) {
            context.commit('deleteMedia', picture)
        },
        updateUser(context, data) {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            let dataArray = {
                name: data.username,
                email: data.email,
                password_crypt: data.password
            }
            toggleLoader()
            return axios
                .post(url + '/user/' + userId + '/edit', {data: btoa(JSON.stringify(dataArray))})
                .then(res => {

                    if (res.data.status_code === 200) {
                        this.dispatch('getUser', res.data.value)
                    }

                    return res.data

                })
                .catch(err => console.log(err))

        },
        newPassword(context, data) {

            let dataArray = {
                name: data.pseudo,
                email: data.email,
                password_crypt: data.password
            }
            toggleLoader()
            return axios
                .post(url + '/user/' + data.id + '/npwd', {data: btoa(JSON.stringify(dataArray))})
                .then(res => {
                    toggleLoader()
                    if (res.data.type === 'succeed') {
                        return [{msg: res.data.msg, type: 'succeed'}];

                    }

                    return res.data.map(el => {
                        return {msg: el, type: 'error'}
                    });
                })
                .catch(err => console.log(err))

        },
        resetPassword(context, data) {

            return axios
                .get(url + '/user/' + data + '/rp')
                .then(res => {
                    return res.data
                })
        },
        userExist(context, data) {
            let dataArray = {
                pseudo: data.pseudo,
                email: data.email,
            }
            return axios
                .post(url + '/userexist', dataArray)
                .then(res => {
                    return res.data
                })
                .catch(error => console.log(error))
        },
        dropPicture(context, data) {
            return axios
                .post(url + '/picture/' + data)
                .then(res => {
                    return res.data
                })
                .catch(err => console.log(err))
        },
        getSuccess() {
            return axios
                .get(url + '/success')
                .then(res => {
                    return res.data
                })
                .catch(err => console.log(err))
        },
        getUserSuccess() {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .get(url + '/user/' + userId + '/success')
                .then(res => {
                    return res.data
                })
        },
        getUserEvent() {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;
            return axios
                .get(url + '/user/' + userId + '/events')
                .then(res => {
                    return res.data
                })
        },
        getUserPictures() {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .get(url + '/user/' + userId + '/pictures')
                .then(res => {
                    return res.data
                })
        },
        getEventPictures(context, data) {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .get(url + '/user/' + userId + '/' + data + '/pictures')
                .then(res => {
                    return res.data
                })
        },
        getEventProducts(context, data) {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .get(url + '/user/' + userId + '/' + data + '/products')
                .then(res => {
                    return res.data
                })
        },
        getRanking(context, data) {
            return axios
                .get(url + '/event/' + data)
                .then(res => {
                    return res.data
                }).catch(err => console.log(err));

        },
        getUserScan() {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .get(url + '/user/' + userId + '/scanlist')
                .then(res => {
                    return res.data
                }).catch(err => console.log(err));

        },
        checkSuccess(context, data) {
            let userId = store.state.user ? store.state.user.id : JSON.parse(localStorage.getItem('user')).id;

            return axios
                .post(url + '/user/' + userId + '/checksuccess', {successList: data})
                .then(res => {

                    return res.data
                }).catch(err => console.log(err));
        },
        removeSuccessBaseAction(context) {
            let data = store.state.successBase.length > 0 ? store.state.successBase.shift() : null;

            context.commit('setSuccessBase', data)
        },
        removeSuccess(context) {
            let data = store.state.successList.length > 0 ? store.state.success.shift() : null;
            context.commit('setSuccess', data)

        },
        getUsersRanking(context, type) {
            return axios
                .get(url + '/users/ranking/' + type)
                .then(res => {
                    return res.data
                }).catch(err => console.log(err));
        }

    }

    // plugins: [vuexLocal.plugin],//use localStorage
});
